import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { ErrorHandling, DisplayCard } from 'components';
import { actionStartAppLoader, actionEndAppLoader, actionGetDisplayAreasByType } from 'actions';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(5)
  }
}));

const DonationAreas = (props) => {

  const dispatch = useDispatch()
  const classes = useStyles();

  const [errorMsg, seterrorMsg] = useState("");

  const loading = useSelector(state => state.reducerDisplayAreas.loading);
  const displayAreas = useSelector(state => state.reducerDisplayAreas.displayAreas);
  const error = useSelector(state => state.reducerDisplayAreas.displayAreasError);

  useEffect(() => {
    actionGetDisplayAreasByType(dispatch, 'donationpage', null, false);
  }, [])

  useEffect(() => {
    if (loading)
      actionStartAppLoader(dispatch);
    else
      actionEndAppLoader(dispatch);
  }, [loading])

  useEffect(() => {
    seterrorMsg(error);
  }, [error])

  const errorcancelhandle = () => {
    seterrorMsg("");
  }

  const onClickDonateHandler = (ref) => {
    props.history.push({
      pathname: 'donation/Area/' + ref.DisplayAreaNo
    })
  }

  return (
    <Grid container spacing={2} className={classes.root}>
      <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
      <Grid container spacing={2}>
        {displayAreas?.filter(area => area.ShowOnline).sort((a, b) => a.SortOrder - b.SortOrder).map(area => {
          return <Grid item xs={12} md={4} key={"Donation_Area_" + area.DisplayAreaNo}><DisplayCard Title={area.AreaName} Description={area.DisplayText} ButtonText='Donate' ButtonCallBack={onClickDonateHandler} ButtonCallBackReference={area} /></Grid>
        })}
      </Grid>
    </Grid>
  );
};

export default DonationAreas;